(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_footer-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const EXPANDED = window.matchMedia('(min-width: 640px)');

    const sync = () => {
      for (const column of document.querySelectorAll('.cultiva-footer__col')) {
        column.open = EXPANDED.matches;
      }
    };

    sync();
    EXPANDED.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();
  } catch(e) { console.error(e); }
})();

})();
